<template>
  <div>
    <div class="portlet light maintenance_mode">
      <div class="module-name">MAINTENANCE MODE</div>
      <div class="portlet-title tabbable-line">
        <div class="caption">
          <span class="caption-subject font-dark bold uppercase">MAINTENANCE MODE</span>
        </div>
      </div>
      <div class="portlet-body">

        <div v-for="account in userAccounts">
          <label><input type="checkbox" :value="account.id" v-model="maintenance_mode"> {{account.organizationName}}</label>
        </div>

        <br>

        <div class="form-group" v-if="maintenance_mode.length">
          <label class="control-label">Message:</label>
          <textarea v-model="maintenance_message" class="form-control" rows="5"></textarea>
        </div>

        <button class="btn green" @click.prevent="selectAll">Select all</button>
        <button class="btn default" @click.prevent="maintenance_mode = []">Select none</button>

        <button data-style="expand-left"
                class="btn green pull-right mt-ladda-btn ladda-button groups-btn-submit submit-maintenance"
                @click.prevent="maintenanceModeSave()">
          <span class="ladda-label">Save</span>
        </button>
      </div>
      <div class="clearfix"></div>
    </div>
    <confirmation
      id="maintenance-confirmation"
      title="Maintenance Mode" question="Are you sure you would like to change this setting?"
                  v-on:confirmed="updateMaintenanceMode()"/>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex'
  import Spinner from '@/components/Spinner';
  import Confirmation from "../../components/modals/ConfirmationModal";

  export default {
    props: ['status', 'message'],
    data() {
      return {
        maintenance_mode: [],
        maintenance_message: ''
      }
    },
    components: {
      Confirmation,
      'vue-spinner': Spinner
    },
    methods: {
      ...mapActions({
        saveGeneralSettingAction: 'saveGeneralSetting',
        loadUserAccounts: 'loadUserAccounts'
      }),
      updateMaintenanceMode() {
        let context = Ladda.create(document.querySelector('.submit-maintenance'));

        let data = {
          maintenance_mode: JSON.stringify(this.maintenance_mode),
          maintenance_message: this.maintenance_message
        };

        this.saveGeneralSettingAction({data, context, 'message': 'Maintenance mode updated!'});
      },
      selectAll() {
        this.maintenance_mode = this.userAccounts.map(item => {
          return item.id;
        })
      },
      maintenanceModeSave() {
        $('#maintenance-confirmation').modal('show');
      }
    },
    computed: {
      ...mapGetters({
        userAccounts: 'getUserAccounts'
      })
    },
    created() {

      let status;

      try {
        status = JSON.parse(this.status)
      } catch (e) {

      }

      this.maintenance_mode = Array.isArray(status) ? status : [];
      this.maintenance_message = this.message;
      this.loadUserAccounts();
    }
  }
</script>
<style>
  .maintenance_mode label {
    padding: 5px 10px;
  }
</style>



// WEBPACK FOOTER //
// MaintenanceMode.vue?3deb50b8